
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 3.667a7.333 7.333 0 100 14.666 7.333 7.333 0 000-14.666zM1.834 11a9.167 9.167 0 1118.333 0 9.167 9.167 0 01-18.334 0z","fill":"#F68E87"}}),_c('path',{attrs:{"d":"M11 9.167c.506 0 .917.41.917.916v5.5a.917.917 0 01-1.833 0v-5.5c0-.506.41-.916.916-.916zM12.375 6.875a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0z","fill":"#F68E87"}})])
          )
        }
      }
    